// extracted by mini-css-extract-plugin
export default {"header":"AvlModal_header__Bh5vD"};